<form class="modal-body" [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <p class="centermodal__title">{{ 'signature.changeSignatureAppearance' | translate }}</p>

  <div class="centermodal__form">
    <app-signature-pad
      [font]="form.get('signature.font').value"
      [format]="form.get('signature.format').value"
      (formatChange)="form.get('signature.format').setValue($event); form.get('initials.format').setValue($event)"
      (fontChange)="form.get('signature.font').setValue($event); form.get('initials.font').setValue($event)"
      (canSubmitForm)="canSubmitForm = $event"
      (signatureTextChange)="form.get('signature.text').setValue($event)"
      (initialsTextChange)="form.get('initials.text').setValue($event)"
      #signaturePad
    >
    </app-signature-pad>
  </div>
  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled-cancel" (click)="modal.dismiss()">{{ 'button.cancel' | translate }}</button>
    <button type="submit" [disabled]="!canSubmitForm" class="btn-L btn-filled">{{ 'button.save' | translate }}</button>
  </div>
</form>
